import React from 'react';
import { Box, Center } from '@tapresearch/ui/components';
export var NoResultsFound = function() {
    return /*#__PURE__*/ React.createElement(Center, {
        my: 8,
        fontSize: "md",
        color: "gray.500",
        fontWeight: "medium",
        variant: "center",
        flexDirection: "column",
        alignItems: "flex-start",
        p: 4
    }, /*#__PURE__*/ React.createElement(Box, {
        mb: 2
    }, "No responses to this question were found matching your filter criteria."), "Please try different or less specific filter options.");
};
